import { ICON__rotate_solid } from '@/assets/icons_fa';
import { UI_PRIMITIVE__button_with_icon_animated } from '@/components/ui/UI_PRIMITIVE__button_with_icon_animated';
import { UI_PRIMITIVE__tooltip } from '@/components/ui/UI_PRIMITIVE__tooltip';
import { CONSTANTS_TIME__client } from '@/constants/CONSTANTS_TIME__client';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { remote_workspace_user_credits_limit_reset } from '@/state/workspace/user/remote_workspace_user_credits_limit_reset';
import { RequestWorkspaceUserCreditsLimitReset } from '@shared/dto/+workspace/workspace_user/_requests/request_workspace_user_credits_limit_reset';
import { DTO__workspace_user } from '@shared/dto/+workspace/workspace_user/DTO__workspace_user';
import { useState } from 'react';

interface Props {
  user: DTO__workspace_user;
}

export function WSTableUserCreditLimitReset({ user }: Props) {
  const dispatch = use_dispatch();

  const [isLoading, setIsLoading] = useState(false);

  async function onClick() {
    setIsLoading(true);

    let request = new RequestWorkspaceUserCreditsLimitReset();
    request.workspace_id = user.workspace_id;
    request.workspace_user_id = user._id;

    await dispatch(remote_workspace_user_credits_limit_reset(request));
    setIsLoading(false);
  }

  return (
    <UI_PRIMITIVE__tooltip delay_duration={0} tooltip_title={'Reset current month statistics'}>
      <UI_PRIMITIVE__button_with_icon_animated
        disabled={isLoading}
        className="!p-0"
        iconClassNameBase="!text-component-item-foreground !w-5 !h-5"
        iconClassNameHovered="!text-bar-foreground"
        variant={'no-border-on-component'}
        onClick={onClick}
        renderDelay={CONSTANTS_TIME__client.TIMEOUT_DELAY_BEFORE_FIRST_ANIMATION_RENDER}
        Icon={ICON__rotate_solid}
      />
    </UI_PRIMITIVE__tooltip>
  );
}
